module.exports = __webpack_public_path__ + "img/car-movieec-phev.2700a2bf.jpg";